/* eslint-disable */
import _ from 'lodash';
import qs from 'qs';

const initialState = {
  incentives: [],
  incentive: [],
  paging: {
    number: 1,
    size: 20
  },
  meta: [],
  fetching: false,
  fetched: false,
  errors: {}
};

export default function incentivesReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_INCENTIVE_PENDING':
    case 'ADD_INCENTIVES_PENDING':
    case 'GET_INCENTIVES_PENDING': {
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: {}
      };
    }
    // Deliberately not grouped with the cases above: `fetching` drives the "Loading..." state
    // that replaces the whole form, and an update is submitted from a form that stays on screen.
    case 'UPDATE_INCENTIVES_PENDING': {
      return {
        ...state,
        errors: {}
      };
    }
    case 'CLEAR_INCENTIVE_ERRORS': {
      return {
        ...state,
        errors: {}
      };
    }
    case 'GET_INCENTIVE_FULFILLED': {
      const data = action.payLoad.data;
      const meta = action.payLoad.meta;
      const newMeta = meta;

      const incentiveTypes = {};

      // TODO remove
      _.each(meta['incentive-types'], (value, key) => {
        key = key.replace(/-/g, '_');
        incentiveTypes[key] = value;
      });
      newMeta['incentive-types'] = incentiveTypes;

      return {
        ...state,
        fetching: false,
        fetched: true,
        incentive: data,
        meta: newMeta
      };
    }
    case 'ADD_INCENTIVE_FULFILLED': {
      return {
        ...state
      };
    }
    case 'GET_INCENTIVES_FULFILLED': {
      const lastPage = action.payLoad.links.last;
      let page = state.paging;

      if (lastPage) {
        page = qs.parse(lastPage.split('?')[1]).page;
      } else if (Object.keys(action.payLoad.links).length === 0) {
        page = initialState.paging;
      }

      return {
        ...state,
        fetching: false,
        fetched: true,
        incentives: action.payLoad.data,
        paging: page
      };
    }
    // Every validation error the server sent back, held here for the form to render. None of them
    // are set on the form itself: an error attached to a control only clears when that control
    // validates again, and this form disables several of its controls once an incentive has
    // started, so one of those would leave the Save button disabled until a page reload.
    case 'ADD_INCENTIVES_REJECTED':
    case 'UPDATE_INCENTIVES_REJECTED': {
      return {
        ...state,
        fetching: false,
        errors: action.payLoad || {}
      };
    }
    case 'GET_INCENTIVE_REJECTED':
    case 'GET_INCENTIVES_REJECTED': {
      return {...state};
    }
    default: {
      return {...state};
    }
  }
}
